import { MomentDate } from "app/components/Moment/Moment";
import { EventHelper } from "app/helpers/eventHelper";
import type { EventIncidentType, EventType } from "app/types/eventType";
import type { Element } from "React";
import React from "react";
import "./StartTimeScore.scss";

//
const displayStateScores = (
  event: EventType,
  eventIncidents: EventIncidentType[],
  period: string,
  isEventInExtraTime: boolean
) => {
  const periodType =
    period === "fullTime" ? "scoreDetails" : "currentPeriodScoreDetails";
  const currentHomeScore = EventHelper.getHomeScore(
    eventIncidents[0][`${periodType}`]
  );
  const currentAwayScore = EventHelper.getAwayScore(
    eventIncidents[0][`${periodType}`]
  );
  const homeScoreFT = EventHelper.getHomeScore(
    eventIncidents[0][`scoreDetails`]
  );
  const awayScoreFT = EventHelper.getAwayScore(
    eventIncidents[0][`scoreDetails`]
  );
  const scoreFullTime = (
    <div
      className={`event-score ${
        isEventInExtraTime ? "event-score--extra-time" : ""
      }`}
    >
      {event.showHomePlayerAsFirst ? (
        <React.Fragment>
          {isEventInExtraTime ? (
            <React.Fragment>
              <div>
                {currentHomeScore} - {currentAwayScore} ET
              </div>
              <div>
                {homeScoreFT} - {awayScoreFT} FT
              </div>
            </React.Fragment>
          ) : (
            <div>
              {homeScoreFT} - {awayScoreFT}
            </div>
          )}
        </React.Fragment>
      ) : (
        <React.Fragment>
          {isEventInExtraTime ? (
            <React.Fragment>
              <div>
                {currentAwayScore} - {currentHomeScore} ET
              </div>
              <div>
                {awayScoreFT} - {homeScoreFT} FT
              </div>
            </React.Fragment>
          ) : (
            <div>
              {awayScoreFT} - {homeScoreFT}
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
  return scoreFullTime;
};

export const StartTimeScore = (props: Record<string, any>): Element<"div"> => {
  // TODO  need to cater for other event states when have more data
  const { eventData } = props;
  const eventIncidents = eventData["eventIncidents"];
  const isEventLive = EventHelper.isEventLive(eventData);
  const isEventInExtraTime = EventHelper.isEventInExtraTime(eventData);
  const displayIsEventInExtraTime =
    isEventInExtraTime === true ? "extraTime" : "fullTime";
  // FIXME clean up
  const scoreFullTime =
    eventIncidents &&
    eventIncidents[0][`scoreDetails`].length > 0 &&
    displayStateScores(
      eventData,
      eventIncidents,
      displayIsEventInExtraTime,
      isEventInExtraTime
    );

  return (
    <div className="event__time-section">
      <TopSection
        eventData={eventData}
        scoreFullTime={scoreFullTime}
        isEventLive={isEventLive}
      />
    </div>
  );
};
export default StartTimeScore;

const TopSection = (props: Record<string, any>) => {
  const { eventData, scoreFullTime, isEventLive } = props;
  return (
    <div className="event__time-section--top">
      {isEventLive ? (
        scoreFullTime
      ) : (
        <MomentDate value={eventData["startTime"]} countDown />
      )}
    </div>
  );
};
